/**
 * Date Replacer View
 */

define(function(require, exports, module) {
    'use strict';
    const BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({

        className: 'date-replacer',

        updateClock: function() {
            this.$el.html(window.Playtech.API.formatter.getDateTimeLong(new Date()));
            setTimeout(this.updateClock.bind(this), 1000);
        },

        render: function() {
            this.updateClock();
            return this;
        }

    }, {
        nameOfReplacers: [
            'DATE'
        ]
    });
});
